/**
 * The top-level page segments that live under `app/[locale]/(crm)/`.
 *
 * A route group's name is not a path segment, so the browser cannot tell a CRM page
 * from a public one by looking at the URL — and `lib/api-client.ts` has to, because
 * sending an anonymous visitor of a public page to the staff login is a worse failure
 * than leaving a 401 unhandled.
 *
 * This is the one place the list is written down. Adding a screen to `(crm)/` without
 * adding it here costs the 401 → login redirect on that screen; adding one here that is
 * not under `(crm)/` costs an unwanted redirect. Both are visible on the first visit.
 */
export const CRM_PAGE_SEGMENTS = ['prospects', 'discover', 'marketing', 'admin', 'avm-performance'] as const;

/** True when a `/{locale}/{segment}/…` path is served by the authenticated route group. */
export function isCrmPagePath(pathname: string): boolean {
  const segment = pathname.split('/')[2] ?? '';
  return (CRM_PAGE_SEGMENTS as readonly string[]).includes(segment);
}
